module.exports = __webpack_public_path__ + "img/group-light.797ef3f9.png";